(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    function scrollTrustSlider(blockId, direction) {
    const slider = document.getElementById('trust-slider-' + blockId);
    if (!slider) return;
    
    const slide = slider.querySelector('.trust-slide');
    if (!slide) return;
    
    const slideWidth = slide.offsetWidth;
    const gap = parseInt(getComputedStyle(slider).gap) || 16;
    const scrollAmount = (slideWidth + gap) * direction;
    
    slider.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }

  // Auto-hide navigation arrows if all content is visible
  document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('[id^="trust-slider-"]');
    
    sliders.forEach(slider => {
      const checkScroll = () => {
        const wrapper = slider.closest('.trust-slider-wrapper');
        if (!wrapper) return;
        
        const prevBtn = wrapper.querySelector('.trust-prev');
        const nextBtn = wrapper.querySelector('.trust-next');
        
        if (slider.scrollWidth <= slider.clientWidth) {
          // Content fits, hide arrows
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
        } else {
          // Content needs scrolling, show arrows
          if (prevBtn) prevBtn.style.display = 'flex';
          if (nextBtn) nextBtn.style.display = 'flex';
        }
      };
      
      checkScroll();
      window.addEventListener('resize', checkScroll);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
